export const parseEscapes = (inputString) => {
  const request = `{"any":"${inputString}"}`;
  const parsed = JSON.parse(request);
  return parsed.any;
};
